import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    title: _ctx.title,
    "left-arrow": _ctx.showBack,
    fixed: _ctx.fixed,
    placeholder: "",
    "safe-area-inset-top": "",
    border: false,
    onClickLeft: _ctx.onClickLeft
  }, {
    right: _withCtx(() => [_renderSlot(_ctx.$slots, "right", {}, undefined, true)]),
    _: 3
  }, 8, ["title", "left-arrow", "fixed", "onClickLeft"])]);
}